// extracted by mini-css-extract-plugin
export var icon = "_ql-0";